import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface ProcessRequests {
  processId: string
  concepts: any[]
  startDate: Date | ''
  endDate: Date | ''
  employees: []
}

export async function getProcessRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [
    'process_requests.payroll_id=:payrollId',
    "(payroll_status.code != 'CLOSED' OR payroll_status IS NULL)"
  ]
  if (search) {
    where.push(
      `CONCAT(process_requests.code,processes.name,process_requests.employees_amount,process_requests.concepts_amount,process_requests.user) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by process_requests.updated_at desc'])

  // result
  const response: any = await getData({
    tables: ['pg_process_requests'],
    fields: [
      'process_requests.id',
      'processes.name',
      'process_requests.employees_amount',
      'process_requests.concepts_amount',
      'process_requests.start_date',
      'process_requests.end_date',
      'process_requests.user',
      'payroll_status.code as payroll_status',
      'process_requests.updated_at',
      'process_status.code as status',
      'processed_payrolls.id as processed_payroll_id'
    ],
    join: [
      'INNER JOIN processes ON process_requests.process_id=processes.id',
      'INNER JOIN process_status ON process_requests.process_status_id=process_status.id',
      'LEFT JOIN processed_payrolls ON process_requests.id = processed_payrolls.process_request_id',
      'LEFT JOIN payroll_status ON processed_payrolls.payroll_status_id=payroll_status.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getProcesses() {
  const data = await getData<any>({
    tables: ['pg_processes'],
    fields: ['id', 'name', 'code', 'countries'],
    where: ['is_deleted=false', 'apply_calc=true'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function getProcessStatus() {
  const data = await getData<any>({
    tables: ['pg_process_status'],
    join: [],
    fields: ['id', 'name'],
    where: ['is_deleted=false'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function getConcepts() {
  const data = await getData<any>({
    tables: ['pg_concepts'],
    fields: ['id', "CONCAT(code,' - ',name) as name", 'code', 'processes'],
    where: [`payroll_id =:payrollId`, 'is_inactive=false', 'code is not null'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function getCalendars(lastPayment: string = '') {
  if (lastPayment === null || lastPayment === ('' as string)) return

  const data = await getData<any>({
    tables: ['pg_calendars'],
    fields: [
      "TO_CHAR(start_date,'yyyy-mm-dd') as initialDate",
      "TO_CHAR(end_date,'yyyy-mm-dd') as finalDate"
    ],
    where: [
      `start_date>('${lastPayment ?? ''}')`,
      'payroll_id =:payrollId',
      'is_deleted=false'
    ],
    modifier: ['order by start_date asc'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results[0]
}

export async function getEmployees(endDate: string) {
  const data = await getData<any>({
    tables: ['pg_employees'],
    fields: [
      'distinct employees.id',
      "CONCAT(employees.first_name,' ',coalesce(employees.second_name,''),' ',employees.lastname,' ',coalesce(employees.second_lastname,'')) as name",
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      "CONCAT(employees.code,' - ',employees.first_name,' ',coalesce(employees.second_name,''),' ',employees.lastname,' ',coalesce(employees.second_lastname,'')) as codigo_name",
      'false as isChecked'
    ],
    join: [
      'LEFT JOIN directions ON employees.direction_id=directions.id',
      'LEFT JOIN managements ON employees.management_id=managements.id',
      'LEFT JOIN departments ON employees.department_id=departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id=sucursals.id',
      'LEFT JOIN positions ON employees.position_id=positions.id',
      'LEFT JOIN turns ON employees.turn_id=turns.id'
    ],
    where: [
      'employees.is_deleted=false',
      `employees.payroll_id =:payrollId`,
      `employees.joining_date<='${endDate}'`,
      `(employees.leave_date is null or employees.leave_date>'${endDate}')`
    ],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

let isCalculating = false
export async function createControlCalculate(
  data: ProcessRequests
): Promise<any> {
  if (isCalculating) return false
  isCalculating = true
  try {
    const response: any = await http.post('calc-controller/process-request', {
      processId: data.processId,
      employees: data.employees,
      concepts: data.concepts,
      startDate: data.startDate,
      endDate: data.endDate
    })
    if (response?.data?.data?.error) {
      return response
    }
    return { response }
  } catch (error) {
    return error
  } finally {
    isCalculating = false
  }
}

export async function deleteProcessRequest(id: string): Promise<boolean> {
  const response: any = await http.delete(
    `calc-controller/process-request/${id}`
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
